import React from 'react';
import { Box } from '@mui/material';
import { colors, typography } from '../../styles/theme';
import { CAD_KIND_LABELS } from '../data/cadConstants';
import { formatCadArea, formatCadBlock, formatCadPrice } from '../utils/cadParcelDisplay';
import { getCadKind } from '../utils/cadMasterplan';
import { formatCollectionInquiryItemCountLabel } from '../../Map/utils/collectionInquiryStats';
import CadStockStatusLabel from './CadStockStatusLabel';

/**
 * Meta de card CAD: manzana · superficie · precio · estado con puntito.
 * Manage puede sumar “N consultas” (incluye 0). El visitante no lo ve.
 * Misma info que `formatCadParcelListMeta`, con el gesto de la ficha.
 */
export default function CadParcelListMeta({
  props,
  sx = undefined,
  inquiryTotal = null,
}) {
  const block = formatCadBlock(props?.block);
  const area = formatCadArea(props?.area_m2);
  const price = formatCadPrice(props?.price, props?.currency);
  const kind = getCadKind(props);
  const isLot = kind === 'lot';
  const parts = [];
  if (block) parts.push({ key: 'block', label: block });
  if (area && area !== '—') parts.push({ key: 'area', label: area });
  if (isLot && price && price !== '—') parts.push({ key: 'price', label: price });
  if (inquiryTotal != null) {
    parts.push({ key: 'inquiries', label: formatCollectionInquiryItemCountLabel(inquiryTotal) });
  }

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        columnGap: 0.75,
        rowGap: 0.25,
        fontFamily: typography.fontFamily.primary,
        fontSize: '12px',
        lineHeight: '16px',
        color: colors.textSecondary,
        ...sx,
      }}
    >
      {parts.map((part, index) => (
        <React.Fragment key={part.key}>
          {index > 0 ? <Box component="span" aria-hidden>·</Box> : null}
          <Box component="span">{part.label}</Box>
        </React.Fragment>
      ))}
      {parts.length > 0 ? <Box component="span" aria-hidden>·</Box> : null}
      {isLot ? (
        <CadStockStatusLabel status={props?.stock_status} />
      ) : (
        <Box component="span">{CAD_KIND_LABELS[kind]}</Box>
      )}
    </Box>
  );
}
